/**
 * Multiplicador do card "última leitura" (Conferência mobile): inteiro em [1, 999].
 * NaN / menor que 1 → 1; frações truncam (mesma regra de pacotes do resto do app).
 */
export function clampMultiplicador(n: number): number {
  if (!Number.isFinite(n)) return 1;
  return Math.min(999, Math.max(1, Math.floor(n)));
}

/**
 * Contagem do item = base ANTES da leitura + (mult × unidades por embalagem lida).
 * Bipar a caixa de 6 e setar ×12 dá base + 12×6 = base + 72.
 */
export function calcularContagemMultiplicada(
  baseAntes: number,
  mult: number,
  unidadesPorPacote: number,
): number {
  return baseAntes + clampMultiplicador(mult) * unidadesPorPacote;
}
